import { NavLink } from 'react-router-dom'

const SUB_TABS = [
  { id: 'grid', label: 'Products', path: '/inventory' },
  { id: 'product-type', label: 'Product Type', path: '/inventory/product-type' },
] as const

export function DashboardSubTabs() {
  return (
    <div role="tablist" aria-label="Dashboard view" className="flex gap-1">
      {SUB_TABS.map((tab) => (
        <NavLink
          key={tab.id}
          to={tab.path}
          end={tab.path === '/inventory'}
          data-testid={`dash-subtab-${tab.id}`}
          className={({ isActive }) =>
            `h-7 px-3 text-xs border inline-flex items-center ${
              isActive
                ? 'border-[var(--text-primary)] text-[var(--text-primary)] font-semibold'
                : 'border-[var(--line-warm)] text-[var(--ink-2)] hover:border-[var(--ink-2)]'
            }`
          }
          style={{ background: 'var(--surface-card)', textDecoration: 'none' }}
        >
          {tab.label}
        </NavLink>
      ))}
    </div>
  )
}
